import React from 'react';
const NoMatch = () => {
  return <div>Page not found!</div>;
};

export default NoMatch;
